export class UsuarioAutorizacoes {
    constructor(
        public funcionalidadeId: number,
        public ativa: boolean,
        public rota: string,
        public grupo: string,
        public nivel: number,
        public autorizacaoId: number,
        public estaAutorizado: boolean,
        public podeAcessar: boolean,
        public podeAlterar: boolean,
        public podeExcluir: boolean,
        public podeIncluir: boolean,
        public podeListar: boolean,
        public tipo: number, // Tipo de Funcionalidade: 1 - Janela, 2 - Relatorio, 3 - Especifica
        public especifica: string
    ) {}
}
